import React, { useEffect, useRef } from 'react';

const pad = (value) => String(value).padStart(2, '0');

const HOURS = Array.from({ length: 24 }, (_, index) => index);
const MINUTES = Array.from({ length: 60 }, (_, index) => index);

/**
 * Одна колонка выбора — часы или минуты. При открытии панели список
 * прокручивается к выбранному значению.
 */
const TimeColumn = ({ title, items, selected, onSelect }) => {
  const listRef = useRef(null);

  useEffect(() => {
    const list = listRef.current;
    const active = list && list.querySelector('.dti-time-option--selected');
    if (!list || !active) return;
    // scrollIntoView прокрутил бы и страницу под попапом — двигаем только список.
    list.scrollTop = active.offsetTop - list.clientHeight / 2 + active.clientHeight / 2;
  }, [selected]);

  return (
    <div className="dti-time-column">
      <div className="dti-time-title">{title}</div>
      <div className="dti-time-list" ref={listRef} role="listbox" aria-label={title}>
        {items.map((item) => (
          <button
            key={item}
            type="button"
            role="option"
            aria-selected={item === selected}
            className={`dti-time-option${item === selected ? ' dti-time-option--selected' : ''}`}
            // Без этого клик уводит фокус из поля и попап закрывается до onClick.
            onMouseDown={(event) => event.preventDefault()}
            onClick={() => onSelect(item)}
          >
            {pad(item)}
          </button>
        ))}
      </div>
    </div>
  );
};

/**
 * Панель выбора времени с раздельными списками часов и минут.
 * Заменяет одноколоночный список react-datepicker, который умеет только
 * фиксированный шаг (15 минут) и не даёт выбрать произвольную минуту мышью.
 *
 * hours/minutes — числа или null, когда значение ещё не задано.
 * onSelect(hours, minutes) всегда получает оба компонента времени.
 */
const TimePanel = ({ hours, minutes, onSelect }) => (
  <div className="dti-time-panel">
    <TimeColumn
      title="Часы"
      items={HOURS}
      selected={hours}
      onSelect={(nextHours) => onSelect(nextHours, minutes === null ? 0 : minutes)}
    />
    <TimeColumn
      title="Минуты"
      items={MINUTES}
      selected={minutes}
      onSelect={(nextMinutes) => onSelect(hours === null ? 0 : hours, nextMinutes)}
    />
  </div>
);

export default TimePanel;
